import { isCaptureLeftToServer } from '@client/trpc/error-classification';
import type { ErrorBoundaryProps } from '@sentry/react';

/**
 * `beforeCapture` for a `Sentry.ErrorBoundary` that a tRPC failure can reach: drops the
 * boundary's own report of an error the server marked `clientCapture: false` (CUR-1962). The
 * boundary captures on a scope forked for that one error, so only its event is discarded.
 */
export const skipCaptureLeftToServer: NonNullable<ErrorBoundaryProps['beforeCapture']> = (scope, error) => {
    if (isCaptureLeftToServer(error)) {
        scope.addEventProcessor(() => null);
    }
};
